import { ButtonType, ButtonConfig } from '@mm/state/model/ButtonModel';
import TagModel from '@mm/state/model/TagModel';

export type ButtonRequestModel = {
  type: ButtonType;
  name: string;
  sortOrder: number;
  id?: number;
  tags?: TagModel[];
  config: ButtonConfig;
  validated?: boolean;
};

export type MakeButton = {
  type: ButtonType;
  name: string;
  sortOrder: number;
  id?: number | null;
  tags?: TagModel[];
  configExtendObject?: ButtonConfig;
};

export const makeButton = ({
  type,
  name,
  sortOrder,
  id,
  tags,
  configExtendObject,
}: MakeButton) => {
  const button: ButtonRequestModel = {
    type,
    name,
    sortOrder,
    config: { ...configExtendObject },
  };

  if (tags) {
    button.tags = tags;
  }

  return id ? Object.assign({ id }, button) : button;
};
